import React, { useState } from "react";
import { 
  Grid, Typography, Box, MenuItem, Stack, Paper, 
  TextField, Switch, FormControlLabel, Button, CircularProgress 
} from "@mui/material"; // MUI 7 এ Grid ডিফল্টভাবে Grid2
import { Assignment } from "@mui/icons-material";
import { SignatureField } from "../../../../../../CustomForm";

const ConsentSection = ({ formData, handleChange, loadingReasons, consentReasons, isEditing = false, fullName }) => {
  const [showPad, setShowPad] = useState(false);
  const showSignatureAndDate = isEditing || (formData.able_to_consent && formData.given_consent);
  const existingSignatureUrl = isEditing && formData.signature ? formData.signature : "";

  // MUI 7 অপ্টিমাইজড ইনপুট স্টাইল
  const inputStyle = {
    "& .MuiFilledInput-root": { 
      bgcolor: "#f8fafc", 
      borderRadius: "14px", 
      border: "1px solid #f1f5f9",
      transition: "0.2s",
      "&:hover": { bgcolor: "#f1f5f9" },
      "&.Mui-focused": { bgcolor: "#fff", borderColor: "primary.main" }
    },
    "& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after": { 
      borderBottom: "none !important" 
    }
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 3, fontWeight: 900, color: "#1e293b", display: 'flex', alignItems: 'center', gap: 1.5, letterSpacing: 0.5 }}>
        <Box sx={{ p: 0.8, bgcolor: 'primary.main', borderRadius: '8px', display: 'flex' }}>
            <Assignment sx={{ fontSize: 16, color: "#fff" }} />
        </Box> 
        BASIC CONSENT DETAILS
      </Typography>

      <Grid container spacing={3}>
        {/* MUI 7: Grid item এর পরিবর্তে সরাসরি size ব্যবহার */}
        <Grid size={{ xs: 12, md: 6 }}>
          {loadingReasons ? (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ p: 2 }}>
                <CircularProgress size={20} />
                <Typography variant="caption">Loading reasons...</Typography>
            </Stack>
          ) : (
            <TextField
              select fullWidth label="Consent Reason" variant="filled"
              value={formData.consent_reason || ""}
              onChange={(e) => handleChange("consent_reason", e.target.value)}
              sx={inputStyle}
            >
              {consentReasons?.map((r) => <MenuItem key={r.id} value={r.id} sx={{ fontSize: '0.9rem' }}>{r.name}</MenuItem>)}
            </TextField>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth type="datetime-local" label="Consent Date & Time" variant="filled"
            value={formData.consent_datetime ? formData.consent_datetime.slice(0, 16) : ""}
            onChange={(e) => handleChange("consent_datetime", e.target.value)}
            // MUI 7 আধুনিক প্যাটার্ন
            slotProps={{ inputLabel: { shrink: true } }}
            sx={inputStyle}
          />
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth multiline rows={3} label="Details of care / support decision" variant="filled"
            value={formData.details_of_care || ""}
            onChange={(e) => handleChange("details_of_care", e.target.value)}
            sx={inputStyle}
          />
        </Grid>

        <Grid size={12}>
          <Paper elevation={0} sx={{ p: 3, bgcolor: "#f8fafc", borderRadius: "20px", border: "1px solid #e2e8f0" }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} justifyContent="space-around">
              <FormControlLabel
                control={
                    <Switch 
                        checked={formData.able_to_consent || false} 
                        onChange={(e) => handleChange("able_to_consent", e.target.checked)} 
                    />
                }
                label={<Typography sx={{ fontWeight: 800, fontSize: "0.85rem", color: '#475569' }}>Is {fullName || "the individual"} able to consent?</Typography>}
              />
              <FormControlLabel
                control={
                    <Switch 
                        checked={formData.given_consent || false} 
                        onChange={(e) => handleChange("given_consent", e.target.checked)} 
                        color="success" 
                    />
                }
                label={<Typography sx={{ fontWeight: 800, fontSize: "0.85rem", color: '#475569' }}>Has consent been granted?</Typography>}
              />
            </Stack>
          </Paper>
        </Grid>

        {showSignatureAndDate && (
          <Grid size={12}>
            <Stack spacing={3} sx={{ mt: 1 }}>
              <TextField
                fullWidth label="Alternative consent method (if not signed)" variant="filled"
                placeholder="e.g. Verbal, Witnessed, etc."
                value={formData.consent_not_signed_method || ""}
                onChange={(e) => handleChange("consent_not_signed_method", e.target.value)}
                sx={inputStyle}
              />
              
              <Paper variant="outlined" sx={{ p: 4, borderRadius: "20px", borderStyle: 'dashed', textAlign: 'center', bgcolor: "#fff", transition: '0.3s', '&:hover': { borderColor: 'primary.main' } }}>
                <Typography variant="caption" sx={{ fontWeight: 900, color: "#64748b", mb: 2, display: 'block', letterSpacing: 1 }}>SIGNATURE VERIFICATION</Typography>
                
                {existingSignatureUrl && !showPad ? (
                  <Box>
                    <Box sx={{ bgcolor: '#f1f5f9', p: 2, borderRadius: '12px', display: 'inline-block', mb: 2 }}>
                        <img src={existingSignatureUrl} alt="Signature" style={{ maxHeight: 80, mixBlendMode: 'multiply' }} />
                    </Box>
                    <br />
                    <Button 
                        variant="contained" size="small" disableElevation
                        onClick={() => setShowPad(true)} 
                        sx={{ borderRadius: "10px", textTransform: 'none', fontWeight: 800, bgcolor: '#0f172a' }}
                    >
                        Replace Signature
                    </Button>
                  </Box>
                ) : (
                  <SignatureField label="Draw Signature" value="" onChange={(val) => handleChange("signature", val)} />
                )}
              </Paper>

              <TextField
                fullWidth label="Consent Provider / Authorized Person" variant="filled"
                value={formData.consent_provider || ""}
                onChange={(e) => handleChange("consent_provider", e.target.value)}
                sx={inputStyle}
              />
            </Stack>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default ConsentSection;